import React, { Component } from 'react';
import 'styles/app.css';
import 'animate.css/animate.css';

//NODE MODULES
import TransitionGroup from 'react-transition-group/TransitionGroup'
import classNames from 'classnames';

import { PAGES, WORK } from 'react.constants';

import Page from './PageContainer';
//APP PAGES
import IntroPage from './IntroPage';
// import AboutPage from './AboutPage';
import AboutPageOne from './AboutPageOne';
import AboutPageTwo from './AboutPageTwo';
import AboutPageThree from './AboutPageThree';
import ContactPage from './ContactPage';
import ServicesPage from './ServicesPage';
import PortfolioPage from './PortfolioPage';

import Navigation from './Navigation';

import axios from 'axios';

import { Howl } from 'howler'

import { md } from 'scripts/util';

const EVENTS = window.events
const { TimelineMax, Sine } = window

class App extends Component {
	constructor(props) {
		super(props);

		this.state = {
			previousPageIndex: null,
			currentPageIndex: null,
			nextPageIndex: 0,
			portfolio: null,
			animating: false,
			isMobile: !md().mobile() ? false : true
		}
	}

	componentDidMount() {
		let url = window.location.search
		let portfolioCheck = url.substr(0, 11) === '?portfolio=' ? url.substr(11, url.length) : false;


		// let portfolioCheck = window.location.pathname.split('/')[1];

		if(portfolioCheck && (portfolioCheck != 'home' && portfolioCheck != 'about' && portfolioCheck != 'services' && portfolioCheck != 'contact')){
			this.getPortfolio(portfolioCheck)
			let acc = document.getElementById('animation_container')
			let loader = document.getElementById('_preload_div_')
			loader.classList.add('dark')
			acc.parentNode.removeChild(acc);
			return;
		}

		window.addEventListener('newPage', this.handleNewPage);
		// window.addEventListener('animPage', this.hideReact);
		window.addEventListener('hidePage', this.hideReact);

		// window.dispatchEvent(EVENTS.animateMonster);

	}

	getPortfolio(string) {
		// Optionally the request above could also be done as
		axios.get('https://savage.devlink.online/api/v1/portfolio/' + string, {
		// axios.get('/api/v1/portfolio/' + string, {
			crossdomain: true
		})
		.then((response) => {
			if(response.data.code == 'OK'){
				console.log(response)
				this.gotoPortfolioPage(response.data, string);
			}else{
				alert("You are trying to view a page that does not exist.")
				this.returnHome();
			}
		});
		// .catch((error) => {
		//
		// });
	}

	returnHome() {
		document.location.href="/";
	}

	gotoPortfolioPage(portfolio, title) {
		this.setState({
			portfolio: portfolio.projects,
			portfolioFilters: portfolio.filters,
			portfolioTitle: title,
			currentPageIndex: 6
		})

	}

	handleNewPage = (e) => {
		let index = e.detail;
		// console.log(e);
		this.renderNewPage(index);
	}

	hideReact = (e) => {
		if(this.state.nextPageIndex !== null){
			return;
		}
		let index = (e.detail !== null && typeof e.detail !== 'undefined') ? e.detail : e
		let { nextPageIndex, currentPageIndex } = this.state;

		this.setState({nextPageIndex: index}, () => {
			this.setState({currentPageIndex: null, previousPageIndex: this.state.currentPageIndex})
		})
	}



	renderNewPage(index) {
		let prev = this.state.currentPageIndex !== null ? this.state.currentPageIndex : this.state.previousPageIndex
		this.setState({currentPageIndex: index, previousPageIndex: prev})
	}

	animateNextPage = () => {
		if(this.state.nextPageIndex === null){
			return;
		}
		// console.log("NEXT", this.state.nextPageIndex)
		// if(this.state.nextPageIndex === 0){
		// 	window.dispatchEvent(EVENTS.page0, false)
		// } else {
			window.dispatchEvent(EVENTS["animPage" + this.state.nextPageIndex], false);
		// }
	}


	pageEntering = () => {
		// console.log('page enetering')
		// this.setState({ animating: true })
	}

	pageEntered = () => {
		// console.log("TRANS FINISH", this.state.nextPageIndex)
		this.setState({ nextPageIndex: null})
		// this.setState({ animating: false })
		// if(this.waiting !== null){
		// 	this.gotoPage(this.waiting);
		// 	this.waiting = null;
		// }
	}


	renderCurrentPage() {
		let { currentPageIndex, nextPageIndex, portfolio, portfolioFilters, portfolioTitle } = this.state
		switch (currentPageIndex) {
	    case 0:
	      return <IntroPage
	      			key={currentPageIndex}
	      			homeToAbout={this.homeToAbout}
	      			animation={{
	      				duration: 0.8,
	      				staggerDuration: 0.4,
	      				staggerDelay: 0.4
	      			}}
      				/>
	    case 1:
	      return <AboutPageOne
	      			key={currentPageIndex}
	      			animation={{
	      				duration: 0.8,
	      				staggerDuration: 0.4,
	      				staggerDelay: 0.4
	      			}}
	      			/>
	    case 2:
	      return <AboutPageTwo
	      			key={currentPageIndex}
	      			animation={{
	      				duration: 0.8,
	      				staggerDuration: 0.4,
	      				staggerDelay: 0.4
	      			}}
	      			/>
	    case 3:
	      return <AboutPageThree
	      			key={currentPageIndex}
	      			animation={{
	      				duration: 0.8,
	      				staggerDuration: 0.4,
	      				staggerDelay: 0.4
	      			}}
	      			/>
	    case 4:
	      return <ContactPage
	      			key={currentPageIndex}
	      			animation={{
	      				duration: 0.8,
	      				staggerDuration: 0.24,
	      				staggerDelay: 0.08
	      			}}
	      			/>
	    case 5:
	      return <ServicesPage
	      			key={currentPageIndex}
	      			animation={{
	      				duration: 0.8,
	      				staggerDuration: 0.24,
	      				staggerDelay: 0.08
	      			}}
	      			/>
	    case 6:
	      return <PortfolioPage
	      			key={currentPageIndex}
	      			portfolio={portfolio}
	      			title={portfolioTitle}
	      			filters={portfolioFilters}
	      			animation={{
	      				duration: 0.8,
	      				staggerDuration: 0.24,
	      				staggerDelay: 0.08
	      			}}
	      			/>
	    default:
	      return null;
	  }
	}



	gotoHome = () => {
		if(this.state.portfolio === null){
			if(this.state.currentPageIndex === 5 && this.state.previousPageIndex === 0){
				this.renderNewPage(0);
			} else {
				this.hideReact(0);
			}
		} else {
			this.returnHome();
		}
	}

	showAbout = () => {

		if(this.state.currentPageIndex === 0){
			this.homeToAbout()
		} else if(this.state.currentPageIndex === 1 || this.state.currentPageIndex === 2 || this.state.currentPageIndex === 3){
			return;
		} else if(this.state.previousPageIndex === 1){
			this.renderNewPage(1);
		} else {
			this.hideReact(1);
		}
	}

	homeToAbout = () => {
		this.setState({nextPageIndex: 1})
		window.dispatchEvent(EVENTS.animPage1, false);
		this.animateToAbout();
	}

	animateToAbout = () => {
	    var tween = new TimelineMax()
	    let el = document.getElementById('IntroPage');

	    tween
	    .to(el, 0.72, {
	      x: '-=948',
	      ease: Sine.easeIn
	    })
	}

	showContact = () => {
		console.log("CONTACT", this.state.previousPageIndex)
		if(this.state.previousPageIndex === 4){
			this.renderNewPage(4);
		} else {
			this.hideReact(4);
		}
	}

  render() {
  	let { currentPageIndex, nextPageIndex,  isMobile } = this.state
  	let currentPage = this.renderCurrentPage()

  	let classes = classNames({
  		'mobile': isMobile,
  		'desktop': !isMobile,
  		'portfolio': this.state.portfolio !== null
  	})


  	let pageContainer = currentPage ?
  		<Page
  			child={currentPage}
  			key={currentPageIndex}

  			pageTransitionStart={this.pageEntering}
  			pageTransitionFinish={this.pageEntered}
  			pageExitFinish={this.animateNextPage}
  			nextPageIndex={nextPageIndex}
  			currentPageIndex={currentPageIndex}
  			isMobile={isMobile}
  			events={EVENTS}
  			hideReact={this.hideReact}
		/>
		: null

    return (
      <div id="App" className={classes}>
      	<Navigation
      		showServices={() => { this.renderNewPage(5); } }
      		showAbout={this.showAbout}
      		showContact={this.showContact}
      		showIntro={this.gotoHome}
      		fullNav={this.state.portfolio === null}
      		animating={nextPageIndex !== null}
      	/>
        <TransitionGroup component="div" className="page-container">
        	{pageContainer}
        </TransitionGroup>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/scripts/containers/App.js